import { render, staticRenderFns } from "./DeleteResource.vue?vue&type=template&id=3acd1610&scoped=true"
import script from "./DeleteResource.vue?vue&type=script&lang=js"
export * from "./DeleteResource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acd1610",
  null
  
)

export default component.exports